import React from 'react';
import '../styles/components.css';
import FaIcon from "../utils/FaIcon";

const TopBar = () => {
  return (
    <div className="top-bar">
      <div>
        <a href='https://maps.app.goo.gl/qzNzBJmMjfz6SASk8' target='_blank' rel='noopener noreferrer'>
          <FaIcon icon="location-dot" />
          <b> Masthenhalli, Kaiwara, India</b>
        </a>
      </div>
      <div>
        <a href='tel:+919008688888'>
          <FaIcon icon="phone" />
          <b>+91 90086 88888</b>
        </a>
        <a href='mailto:info@glometal.in' >
          <FaIcon icon="envelope" />
          <b>info@glometal.in</b>
        </a>
      </div>
    </div>
  );
};

export default TopBar;
